import { RequestQuoteButton } from "../../../components/RequestQuoteButton/RequestQuoteButton";
import { useRequestQuote } from "../../context/RequestQuoteContext";

import { type JSX } from "react";
import { useTranslation } from "react-i18next";

import PrevIcon from "@mui/icons-material/ChevronLeft";
import NextIcon from "@mui/icons-material/ChevronRight";
import SubstructureResetIcon from "@mui/icons-material/Refresh";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

export interface CustomSubconfigurationNavigationButtonsProps {
  onResetClicked(): void;
  onNextClicked(): void;
  onPreviousClicked(): void;
  nextDisabled: boolean;
  previousDisabled: boolean;
  resetDisabled: boolean;
}

export function CustomSubconfigurationNavigationButtons(
  props: CustomSubconfigurationNavigationButtonsProps,
): JSX.Element {
  const { t } = useTranslation();

  const { enableRequestQuote } = useRequestQuote();

  return (
    <Box
      sx={{
        py: 1,
        justifyContent: "space-between",
        flexDirection: "row",
        display: "flex",
      }}
    >
      <Box>
        <Button
          onClick={props.onResetClicked}
          disabled={props.resetDisabled}
          startIcon={<SubstructureResetIcon />}
        >
          {t("AS:SubconfigurationNavigation.resetItem")}
        </Button>
      </Box>
      <Box display="flex" gap="1rem">
        <Button
          onClick={props.onPreviousClicked}
          disabled={props.previousDisabled}
          variant="contained"
          startIcon={<PrevIcon />}
        >
          {t("AS:SubconfigurationNavigation.previousItem")}
        </Button>

        {enableRequestQuote && props.nextDisabled ? (
          <RequestQuoteButton />
        ) : (
          <Button
            onClick={props.onNextClicked}
            disabled={props.nextDisabled}
            variant="contained"
            startIcon={<NextIcon />}
          >
            {t("AS:SubconfigurationNavigation.nextItem")}
          </Button>
        )}
      </Box>
    </Box>
  );
}
